import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrSeparatorComponent } from './pr-separator.component';

@NgModule({
  declarations: [PrSeparatorComponent],
  imports: [CommonModule],
  exports: [PrSeparatorComponent],
})
export class PrSeparatorModule {}
